<div class="px-4 py-4 sm:px-6 sm:py-5 bg-white rounded-2xl w-full max-w-[760px] box-border">
  <!-- BODY -->
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-7">
    <!-- LEFT: card info -->
    <div class="flex-shrink-0">
      <p class="text-[15px] font-bold text-[#1f2937] m-0 mb-1">Parrainage Carte</p>
      <p class="text-[13px] font-medium text-[#6b7280] m-0">
        Code Carte: <span class="font-bold text-[#3EB2E3]">{{ code }}</span>
      </p>
    </div>

    <!-- DIVIDER -->
    <div class="hidden sm:block w-px self-stretch bg-[#3EB2E3] opacity-30 flex-shrink-0"></div>

    <!-- RIGHT: OTP -->
    <div class="flex flex-col items-center gap-2 flex-1 w-full">
      <form [formGroup]="form" class="flex items-center justify-center gap-0.5 sm:gap-1 w-full">
        <ng-container *ngFor="let ctrl of otpControls; let i = index">
          <mat-form-field
            appearance="outline"
            class="otp-field"
            [class.otp-filled]="
              !hasError && !hasSuccess && form.get('key' + (i + 1))?.value?.length === 1
            "
            [class.otp-error]="hasError"
            [class.otp-success]="hasSuccess"
          >
            <input
              matInput
              #otpInput
              maxlength="1"
              [formControlName]="'key' + (i + 1)"
              (input)="onInput($event, i)"
              (keydown)="onKeyDown($event, i)"
              autocomplete="off"
            />
          </mat-form-field>
          <span
            *ngIf="i < otpControls.length - 1"
            [ngClass]="hasError ? 'text-red-400' : hasSuccess ? 'text-green-500' : 'text-[#3EB2E3]'"
            class="font-bold text-sm sm:text-base flex-shrink-0 mx-px select-none"
          >-</span
          >
        </ng-container>
      </form>
      <p class="text-[11px] sm:text-[12px] font-bold text-[#3EB2E3] m-0 text-center">
        Veuillez entrer votre code secret ici.
      </p>
    </div>
  </div>
</div>
